var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 789,
    height: 321,
    viewBox: "0 0 789 321",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 280.999C31.5 300.999 104.4 334.999 152 310.999C211.5 280.999 192 200.499 215 171.499C238 142.499 266 150.999 290 183.999C314 216.999 356.5 258.499 388 245.999C413.2 235.999 430.833 208.499 436.5 195.999C445.167 167.833 462.9 106.699 464.5 87.4993C466.5 63.4993 489.5 16.4993 514.5 16.4993C538.191 16.4993 554.5 43.4993 559.5 66.4993C564.5 89.4993 589.5 119.999 611 122.499C632.5 124.999 648 122.499 662.5 95.9993C677 69.4993 674 1.99927 698 1.99927C706.5 1.99927 713.5 0.499268 733.5 25.4993C750.3 46.4987 785.5 35.8326 805 25.4993",
    stroke: "#2D76FD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurve);
export default __webpack_public_path__ + "static/media/curve.e26d43f9d789e90091cac3b70acf0cc4.svg";
export { ForwardRef as ReactComponent };